<template>
  <div>
    <el-page-header @back="goBack" content="测评结果设置"></el-page-header>
    <div class="topic-outer">
      <div class="appraisal-center fonts">
        <div class="pub-line">
          <span>分类：</span>
          <span class="glay"
          >{{ detalisObj.categoryName1 }}-{{ detalisObj.categoryName }}</span
          >
        </div>
        <div class="flex-box pub-line">
          <div class="fl1">
            <span>名称：</span>
            <span class="glay">{{ detalisObj.name }}</span>
          </div>
          <div class="fl1">
            <span> 标识：</span>
            <span class="glay">{{ detalisObj.examId }}</span>
          </div>
        </div>

        <div class="flex-box pub-line">
          <div class="fl1">
            <span>解析：</span>
            <span class="glay">{{ detalisObj.schemeName }}</span>
          </div>
          <div class="fl1">
            <span> 题目：</span>
            <span class="glay"
            >共 <i>{{ detalisObj.questions }}</i
            >题</span
            >
          </div>
        </div>
      </div>
    </div>
    <div class="topic-outer ">
      <div class="appraisal-center fonts marr" style="margin-top: 10px;width: 100%">
        <el-tabs class="on_tous_sdas" v-model="resultMode" @tab-click="handleTabClick">
          <el-tab-pane label="基础结果设置" name="resset"></el-tab-pane>
          <el-tab-pane label="魅力设置" name="mlset"></el-tab-pane>
        </el-tabs>
        <div>
          <span>维度：</span>
          <span>
            <el-tag
                :class="{ 'tag-marr': true, activeBg: tagIndex == index }"
                v-for="(item, index) in getWDData"
                :key="item.examDimensionId"
                @click="activeEvent(index, item.code, item.name)"
                effect="plain"
            > {{ item.name }}</el-tag
            >
          </span>
        </div>
        <div style="margin-top: 20px">
          <span>基准：</span>
          <span>
            <el-tag
                :class="{ 'tag-marr': true,'tag-marrs': true, 'active-bg1': tagJzIndex == index }"
                v-for="(item, index) in getJZData"
                :key="index"
                @click="activeEventJz(index, item.code, item.name)"
                effect="plain"
            > {{ item.name }}</el-tag
            >
          </span>
        </div>
        <template v-if="resultMode == 'resset'">
          <div style="margin-top: 20px">
            <el-button type="success" size="small" @click="handleClick('add')"
            >添加结果<i class="el-icon-plus"></i
            ></el-button>
            <span class="subject"
            >共 <i>{{ tagIndex == 0 ? detalisObj.questions : emptyShow(getWDData[tagIndex]).questions }}</i> 题，<i>{{
                tagIndex == 0 ? detalisObj.maxScore : emptyShow(getWDData[tagIndex]).maxScore
              }}</i
            >分
          </span>
          </div>
          <div style="margin-top: 20px">
            <div class="public-table-data">
              <el-table
                  ref="multipleTable"
                  size="medium"
                  :data="getWdResulData"
                  border
                  style="width: 100%"
                  row-key="menuId"
                  v-loading="loading"
              >
                <el-table-column
                    type="index"
                    label="序号"
                    width="60"
                    align="center"
                >
                </el-table-column>
                <el-table-column
                    prop="minScore"
                    label="最小值"
                    width="80"
                    align="center"
                >
                </el-table-column>
                <el-table-column
                    prop="maxScore"
                    label="最大值"
                    width="80"
                    align="center"
                >
                </el-table-column>
                <el-table-column
                    prop="title"
                    label="魅力水平"
                    width="100"
                    align="center"
                >
                  <template slot-scope="scope">
                    <div class="content_div" v-html="scope.row.title"></div>
                  </template>
                </el-table-column>
                <el-table-column
                    prop="content"
                    label="魅力详解"
                    min-width="220"
                    align="center"
                >
                  <template slot-scope="scope">
                    <div class="content_div">{{ setHtmlData(scope.row.content) }}</div>
                  </template>
                </el-table-column>
                <el-table-column
                    label="操作"
                    align="center"
                    fixed="right"
                    min-width="180"
                >
                  <template slot-scope="scope">
                    <el-button
                        size="mini"
                        @click="handleClick('edit', scope.row)"
                        type="primary"
                        plain
                    >编辑
                    </el-button
                    >
                    <el-button
                        size="mini"
                        @click="handleDelete(scope.row)"
                        type="danger"
                        plain
                    >删除
                    </el-button
                    >
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </template>
        <template v-if="resultMode == 'mlset'">
          <div style="margin-top: 20px">
            <el-form
                :model="contentParams"
                label-width="105px"
            >
              <el-row>
                <el-col :span="20">
                  <el-form-item label="魅力剖析：" prop="descr">
                    <rich-text v-if="innerVisible" :keyWord="'descr'"
                               :params="contentParams?contentParams:''"></rich-text>
                  </el-form-item>
                  <el-form-item label="魅力释放：" prop="guideSuggest">
                    <rich-text v-if="innerVisible" :keyWord="'guideSuggest'"
                               :params="contentParams?contentParams:''"></rich-text>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
            <div style="margin-bottom: 20px;margin-left: 105px">
              <el-button type="primary" @click="handleCharmEdit">保存设置</el-button>
            </div>
          </div>
        </template>
      </div>
    </div>
    <!--结果设置-->
    <el-dialog
        title="结果设置"
        :visible.sync="dialogVisible"
        width="720px"
        top="30px"
        :close-on-click-modal="false"
        class="public-dialog"
    >
      <div class="public-dialog-form">
        <el-form
            ref="ruleForm"
            :rules="rules"
            :model="params"
            label-width="80px"
        >
          <el-row type="flex">
            <el-col :span="12">
              <el-form-item label="一级维度">
                <div>{{ resue.name }}</div>
              </el-form-item>
            </el-col>
            <el-col :span="12" v-if=" resue.name!='综合' && resueJz.name!='全部' ">
              <el-form-item label="二级基准">
                <div>{{ resueJz.name }}</div>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row type="flex">
            <el-col :span="12">
              <el-form-item label="最小值" prop="minScore">
                <el-input
                    placeholder="请输入最小值"
                    v-model="params.minScore"
                    type="number"
                    style="width: 262px"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="最大值" prop="maxScore">
                <el-input
                    placeholder="请输入最大值"
                    v-model="params.maxScore"
                    type="number"
                    style="width: 262px"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row type="flex">
            <el-col :span="12">
              <el-form-item label="名称" prop="name">
                <el-input
                    placeholder="请输入名称"
                    v-model="params.name"
                    style="width: 262px"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item label="魅力水平" prop="title">
            <rich-text v-if="innerVisible" @input="changTitle" :keyWord="'title'" :params="params?params:''"></rich-text>
          </el-form-item>
          <el-form-item label="魅力详解" prop="content">
            <rich-text @input="changContent" v-if="innerVisible" :keyWord="'content'" :params="params?params:''"></rich-text>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="public-dialog-footer">
        <el-button size="medium" @click="dialogVisible = false"
        >取 消</el-button
        >
        <el-button size="medium" type="primary" @click="handleEdit"
        >提 交</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
import richText from "../../../components/richText";
import {isEmpty, emptyShow} from "@utils/tools/index";
import Test from "../../WechatConfiguration/Test";

export default {
  components: {
    Test,
    richText,
  },
  data() {
    return {
      //之前的代码
      emptyShow, isEmpty,
      rules: {
        minScore: [
          {
            required: true,
            message: "请输入最小值",
            trigger: "blur",
          },
        ],
        maxScore: [
          {
            required: true,
            message: "请输入最大值",
            trigger: "blur",
          },
        ],
        title: [
          {
            required: true,
            message: "请填写水平",
            trigger: "blur",
          },
        ],
        content: [
          {
            required: true,
            message: "请填写详解",
            trigger: "blur",
          },
        ],
      },
      detalisObj: {},
      loading: false,
      initJZData: [],
      params: {},
      innerVisible: false,
      resueJz: {},
      getJZData: [],
      tagJzIndex: 0,
      getWDData: [], //维度列表
      getWdResulData: [], //维度结果列表
      tagIndex: 0,
      resue: {},
      dialogVisible: false,
      //人格魅力设置
      resultMode: 'resset',
      contentParams: {
        maxScore: 0,
        minScore: 0
      }
    };
  },
  watch: {
    dialogVisible() {
      if (this.dialogVisible == false) {
        this.$refs["ruleForm"].resetFields();
        this.params = {}
        this.innerVisible = false
      }
    }
  },
  created() {
    this.getAppraisalData();
    this.getWDList()
  },
  methods: {
    changContent(e){
      this.params.content = e
    },
    changTitle(e){
      this.params.title = e
    },
    //切换设置结果
    handleTabClick() {
      this.innerVisible = false
      if (this.resultMode == 'resset') {
        this.tagIndex = 0
        this.resue = {
          code: this.getWDData[this.tagIndex].code,
          name: this.getWDData[this.tagIndex].name,
        };
        this.getJZList(this.getWDData[this.tagIndex].code)
      } else {
        this.tagIndex = 1
        this.tagJzIndex = 0
        this.resue = {
          code: this.getWDData[this.tagIndex].code,
          name: this.getWDData[this.tagIndex].name,
        };
        this.getJZList(this.getWDData[this.tagIndex].code)
      }
    },

    /**
     * 魅力释放编辑/增加
     */
    handleCharmEdit() {
      this.$confirm("确认保存数据, 是否继续?", "提示", {
        type: "info",
      }).then(async () => {
        if (!this.contentParams.examResultId) {
          this.contentParams.examDimensionCode = this.resue.code;
          this.contentParams.examDatumCode = this.resueJz.code;
          this.contentParams.examId = this.$route.query.examId;
          const {data: resData} = await this.$post(
              "exam/result/info",
              this.contentParams,
              {
                headers: {
                  isLoading: true,
                },
              }
          );
          if (resData.result != 200) return;
          this.getWdResultList(this.resue.code, this.resueJz.code);
          this.$message.success("添加成功!");
        } else {
          const {data: resData} = await this.$put(
              "exam/result/info",
              this.contentParams,
              {
                headers: {
                  isLoading: true,
                },
              }
          );
          if (resData.result != 200) return;
          this.getWdResultList(this.resue.code, this.resueJz.code);
          this.$message.success("修改成功!");
        }
      });
    },
    /**
     * 获取测评维度列表
     */
    async getWDList() {
      this.getWDData = [];
      this.loading = true;
      const {data: resData} = await this.$get(`exam/dimension/list`, {
        params: {
          examId: this.$route.query.examId,
        },
      });
      this.loading = false;
      if (resData.result != 200) return;
      if (resData.data) {
        this.getWDData = resData.data
      } else {
        this.getWDData = []
      }
      /* tagIndex :激活的是哪个 维度  */
      if (this.getWDData.length != 0) {
        this.resue = {
          code: this.getWDData[this.tagIndex].code,
          name: this.getWDData[this.tagIndex].name,
        };
        this.getJZList(this.getWDData[this.tagIndex].code)
      } else {

        this.tableData = [];
        return
      }
    },
    /**
     * 获取基准列表
     */
    async getJZList(code) {
      this.getJZData = [];
      this.loading = true;
      const {data: resData} = await this.$get(`exam/datum/list`, {
        params: {
          examId: this.$route.query.examId,
          examDimensionCode: code,
        },
      });
      this.loading = false;
      if (resData.result != 200) return;
      if (resData.data) {
        this.getJZData = resData.data;
      } else {
        this.getJZData = []
      }

      /* tagJzIndex :激活的是哪个 基准  */
      if (this.getJZData.length != 0) {
        this.resueJz = {
          code: this.getJZData[this.tagJzIndex].code,
          name: this.getJZData[this.tagJzIndex].name,
        };
        this.getWdResultList(this.resue.code, this.resueJz.code);
      } else {
        this.getWdResultList(this.resue.code);
      }
    },
    /**
     * 获取测评维度结果列表
     */
    async getWdResultList(examDimensionCode, examDatumCode) {
      this.contentParams = {
        maxScore: 0,
        minScore: 0
      }
      this.getWdResulData = []
      this.loading = true;
      let temp = {examId: this.$route.query.examId,}
      if (emptyShow(examDimensionCode)) {
        temp.examDimensionCode = examDimensionCode
      }
      if (emptyShow(examDatumCode)) {
        temp.examDatumCode = examDatumCode
      }
      const {data: resData} = await this.$get(`exam/result/list`, {
        params: temp,
      });
      this.loading = false;
      if (resData.result != 200) return;
      if (resData.data) {
        // this.getWdResulData = resData.data;
        resData.data.map(item => {
          if (item.maxScore == 0 && item.minScore == 0) {
            this.contentParams = item
          } else {
            this.getWdResulData.push(item)
          }
        })
        this.innerVisible = true
      } else {
        this.contentParams = {
          maxScore: 0,
          minScore: 0
        }
        this.getWdResulData = [];
        this.innerVisible = true
      }
    },
    /**
     * 点击维度
     */
    activeEvent(index, code, name) {
      if (this.resultMode == 'mlset') {
        if (name == '综合') {
          this.$message.warning('魅力设置时，综合维度不能操作')
          return
        }
      }
      this.params = {}
      this.innerVisible = false
      this.tagIndex = index;
      this.tagJzIndex = 0
      this.params.examDimensionCode = code;
      this.getJZList(code)
      this.resue = {
        name,
        code,
      };
      if (name == '综合') {
        this.resueJz = {}
      }
    },
    /**
     * 点击基准
     */
    activeEventJz(index, code, name) {
      this.tagJzIndex = index;
      this.resueJz = {
        name,
        code,
      };
      this.params = {}
      this.innerVisible = false
      if (this.resue == "ZHWD_370") {
        this.getWdResultList();
      } else {
        this.getWdResultList(this.resue.code, code);
      }
    },

    async handleClick(type, row = {}) {
      this.clickType = type;
      this.params = {};
      this.dialogVisible = true;
      this.innerVisible = false
      if (type == "add") {
        this.params = {};
        this.innerVisible = true
      }
      if (type == "edit") {
        const {data: resData} = await this.$get(
            `exam/result/info/${row.examResultId}`,
            {
              headers: {
                isLoading: true,
              },
            }
        );
        if (resData.result != 200) return;
        this.params = resData.data;
        this.innerVisible = true
      }
    },
    /**
     * 编辑/增加
     */
    handleEdit() {
      if (parseInt(this.params.minScore) > parseInt(this.params.maxScore)) {
        this.$message.error('最小值不能大于最大值')
        return
      }
      this.$refs.ruleForm.validate((valid) => {
        if (!valid) return;
        this.$confirm("确认保存数据, 是否继续?", "提示", {
          type: "info",
        }).then(async () => {
          if (this.clickType == "add") {
            this.params.examDimensionCode = this.resue.code;
            this.params.examDatumCode = this.resueJz.code;
            this.params.examId = this.$route.query.examId;
            const {data: resData} = await this.$post(
                "exam/result/info",
                this.params,
                {
                  headers: {
                    isLoading: true,
                  },
                }
            );
            if (resData.result != 200) return;
            this.getWdResultList(this.resue.code, this.resueJz.code);
            this.dialogVisible = false;
            this.$message.success("添加成功!");
            this.params = {};
            this.innerVisible = false
          } else {
            const {data: resData} = await this.$put(
                "exam/result/info",
                this.params,
                {
                  headers: {
                    isLoading: true,
                  },
                }
            );
            if (resData.result != 200) return;
            this.getWdResultList(this.resue.code, this.resueJz.code);
            this.dialogVisible = false;
            this.$message.success("修改成功!");
            this.innerVisible = false
          }
        });
      });
    },
    /**
     * 删除
     */
    handleDelete(row) {
      this.$confirm("此操作将永久删除数据, 是否继续?", "提示", {
        type: "warning",
      }).then(async () => {
        const {data: resData} = await this.$delete(
            `exam/result/info/${row.examResultId}`,
            {
              headers: {
                isLoading: true,
              },
            }
        );
        if (resData.result != 200) return;
        this.$message.success("删除成功!");
        this.getWdResultList(this.resue.code);
      });
    },
    //过滤标签数据
    setHtmlData(str) {
      let obj = ''
      if (str) {
        obj = str.replace(/<[^<>]+>/g, '').replace(/&nbsp;/ig, '')
      }
      return obj
    },
    /**
     * 获取测评详情
     */
    async getAppraisalData() {
      this.loading = true;
      const {data: resData} = await this.$get(
          `exam/info/${this.$route.query.examId}`
      );
      this.loading = false;
      if (resData.result != 200) return;
      this.detalisObj = resData.data;
    },

    goBack() {
      this.$router.go(-1);
    },
  },
};
</script>
<style lang="scss" scoped>
.editor {
  line-height: normal !important;
  margin-bottom: 30px;
}

.initialize {
  margin-top: 20px;
}

.appraisal-title {
  color: #3a3a3a;
}

.appraisal-center {
  width: 100%;
  margin: 0 auto;
}

.fonts {
  font-size: 14px;
}

.topic-outer {
  width: 100%;
  background: #fff;
  overflow: hidden;
  margin-top: 20px;
  padding-bottom: 30px;
}

.flex-box {
  display: -webkit-box;
  display: -moz-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
}

.fl1 {
  flex: 1;
  -webkit-flex: 1;
}

.glay {
  color: #8492a6;

  i {
    font-style: normal;
    color: #f56c6c;
  }
}

.pub-line {
  margin-top: 30px;
}

.pub-marr {
  margin-top: 20px;
}

.marr {
  //margin-top: 30px;
}

.tag-marr {
  margin-right: 5px;
  cursor: pointer;
}

.subject {
  color: #8492a6;
  margin-left: 10px;

  i {
    font-style: normal;
    color: #f56c6c;
  }
}

.activeBg {
  background: #b3d8ff;
  color: #fff;
}

.tag-marrs {
  border-color: #fbc4c4;
  color: #f56c6c;
}

.active-bg1 {
  background: #fbc4c4;
  color: #fff;
}

</style>
<style>
.topic-outer .el-tabs__item {
  white-space: pre-wrap;
  text-align: center !important;
  /*line-height: 20px;*/
  /*height: 46px !important;*/

}

.topic-outer .el-form-item {
  margin-bottom: 20px;
}

.topic-outer .ql-container.ql-snow {
  height: 260px;
}

.topic-outer .quill-editor.editor {
  margin-bottom: 0;
}

.on_tous_sdas .el-tabs__nav-wrap {
  width: 300px !important;
}

.on_tous_sdas .el-tabs__nav {
  width: 100% !important;
}

.on_tous_sdas .el-tabs__item {
  width: 50%;
  padding: 0 !important;
  text-align: center;
  line-height: 46px !important;
  font-weight: 600;
}

.on_tous_sdas .el-tabs__active-bar {
  height: 1px !important;
}

.on_tous_sdas .el-tabs__nav-wrap::after {
  height: 1px !important;
}


</style>